module.exports = __webpack_public_path__ + "img/d-zoom-in-icon.7ca4e815.svg";